import { render, staticRenderFns } from "./fp-briefcase.vue?vue&type=template&id=10fee7d2&"
import script from "./fp-briefcase.vue?vue&type=script&lang=js&"
export * from "./fp-briefcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fee7d2')) {
      api.createRecord('10fee7d2', component.options)
    } else {
      api.reload('10fee7d2', component.options)
    }
    module.hot.accept("./fp-briefcase.vue?vue&type=template&id=10fee7d2&", function () {
      api.rerender('10fee7d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fp-briefcase.vue"
export default component.exports